import CoreParamManager from './core-param-manager';
import ParamStore from '../stores/param-store';
import ModelStore from '../stores/model-store';
import UiStateStore from '../stores/ui-state-store';
import FormUiState from '../form-ui-state';
import LocalizationFactory from '../../infrastructure/localization';
import InitialCohort from '../../constants/initial-cohort';
import PasswordMode from '../../constants/password-mode';

export default class ParamManager {
    static validateAndStore(params, componentId) {
        ParamManager.validate(params);
        ParamManager.store(params, componentId);
    }

    static validate(params) {
        CoreParamManager.validate(params);
        ParamManager._validateUserTracking(params);
    }

    static store(params, componentId) {
        CoreParamManager.store(params, componentId);

        let paramStoreModel = ParamStore.getModel(componentId);
        let modelStoreModel = ModelStore.getModel(componentId);
        let uiStateStoreModel = UiStateStore.getModel(componentId);

        LocalizationFactory.initLocalization(componentId).then(() => { FormUiState.setReady(componentId); });

        if (params.formType) {
            modelStoreModel.formType = params.formType;
        }

        if (params.formVariants) {
            uiStateStoreModel.form.formVariants = params.formVariants;
        }

        if (params.localizationOverrides) {
            uiStateStoreModel.form.localizationOverrides = params.localizationOverrides;
        }

        if (paramStoreModel.initialCohort === InitialCohort.passwordlessRegistration) {
            ModelStore.update(componentId, (model) => {
                model.passwordMode = PasswordMode.passwordless;
            });
        }

        if (paramStoreModel.initialCohort === InitialCohort.singlePasswordRegistration) {
            ModelStore.update(componentId, (model) => {
                model.passwordMode = PasswordMode.singlePassword;
            });
        }
    }

    static _validateUserTracking(params) {
        if (!params.tracking.ga) {
            throw new Error('JLS Missing obligatory global parameter called tracking.ga');
        }

        if (!params.tracking.ga.termsCheckBox || !params.tracking.ga.termsCheckBox.category || !params.tracking.ga.termsCheckBox.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.termsCheckBox');
        }

        if (!params.tracking.ga.termsLink || !params.tracking.ga.termsLink.category || !params.tracking.ga.termsLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.termsLink');
        }

        if (!params.tracking.ga.privacyLink || !params.tracking.ga.privacyLink.category || !params.tracking.ga.privacyLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.privacyLink');
        }

        if (!params.tracking.ga.chooseOtherwiseLink || !params.tracking.ga.chooseOtherwiseLink.category || !params.tracking.ga.chooseOtherwiseLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.chooseOtherwiseLink');
        }

        if (!params.tracking.ga.productInformationCheckBox || !params.tracking.ga.productInformationCheckBox.category || !params.tracking.ga.productInformationCheckBox.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.productInformationCheckBox');
        }

        if (!params.tracking.ga.getStartedButton || !params.tracking.ga.getStartedButton.category || !params.tracking.ga.getStartedButton.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.getStartedButton');
        }

        if (!params.tracking.ga.federatedLoginLink || !params.tracking.ga.federatedLoginLink.category || !params.tracking.ga.federatedLoginLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.federatedLoginLink');
        }

        if (!params.tracking.ga.existingLoginLink || !params.tracking.ga.existingLoginLink.category || !params.tracking.ga.existingLoginLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.existingLoginLink');
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/logic/params/param-manager.js
 **/